import {Divider} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'
import {BusinessOfferSlot} from '@yandex-delivery/form/ui/OrderForm/widgets/BusinessOfferSlot'
import {BusinessPlate} from '@yandex-delivery/form/ui/OrderForm/widgets/BusinessPlate/BusinessPlate'
import type {ReactElement} from 'react'

import type {SlotWidgetProps as Props} from '../types'
import {Slot} from './Slot'
import {isBusinessOfferMock, isBusinessPlate, isHeader, isRadio} from './utils'

const divider = css`
  inline-size: calc(100% + ${spacing(4)});
  transform: translateX(${spacing(-2)});
`
/**
 * Виджет слота.
 */
export const SlotWidget = ({config: props}: Props): ReactElement => {
  if (isRadio(props)) {
    return (
      <label>
        <Slot config={props} />
      </label>
    )
  }

  if (isHeader(props)) {
    return (
      <>
        <Slot config={props} />
        <Divider className={divider} />
      </>
    )
  }

  if (isBusinessOfferMock(props)) {
    return <BusinessOfferSlot config={props} />
  }

  if (isBusinessPlate(props)) {
    return <BusinessPlate metricaLabel={props.metrica_label} name="is_business" />
  }

  return <Slot config={props} />
}
